export const classes = {
  wrapper:
    'place-between gap-[14px] px-[22px] py-[14px] border-b border-solid border-black/10 dark:border-white/10',
  iconButton: 'size-[34px] rounded-[10px] text-taupe-2 dark:text-mauve-2',
  date: 'relative px-1 mx-3 text-[18px] font-bold text-taupe-3 cursor-pointer border-b border-transparent transition-colors hover:border-taupe-2 dark:text-mauve-1 dark:hover:border-mauve-2',
  dateMenu: 'mt-3',
  dateWrapper: 'flex items-center',
  closeButton: 'text-taupe-2 dark:text-mauve-2',
};
